import React, { Component } from "react";
import VariantSelector from "./VariantSelector";
import "./detailstyle.css";
import "./style.css";
import { Link } from "react-router-dom";
import Cart from "./Cart";
import ReactHtmlParser from "react-html-parser";
import Slider from "react-slick";

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      setIsOpen: false,
      selectedVariant: null,
      selectedColorValue: null,
      selectedSizeValue: null,
      selectedsizevalue: null,
    };
    let defaultOptionValues = {};
    this.props.product.options.forEach((selector) => {
      defaultOptionValues[selector.name] = selector.values[0].value;
    });
    this.state = { selectedOptions: defaultOptionValues };
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  componentWillMount(prevProps) {
    let defaultOptionValues = {};
    if (prevProps !== this.props) {
      this.props.product.options.forEach((selector) => {
        defaultOptionValues[selector.name] = selector.values[0].value;
      });
      this.setState({
        selectedOptions: defaultOptionValues,
        selectedVariant: null,
        selectedVariantImage: null,
        selectedValue: this.props.product.options[0].values[0].value,
      });
    }
  }

  handleOptionChange(event, fieldName) {
    let selectedOptions = this.state.selectedOptions;
    selectedOptions[fieldName] = `${event.value}`;
    const selectedVariant = this.props.client.product.helpers.variantForOptions(
      this.props.product,
      selectedOptions
    );

    if (fieldName === "Color") {
      this.setState({
        selectedVariant: selectedVariant,
        selectedColorValue: `${event.value}`,
      });
    } else if (fieldName === "Size") {
      this.setState({
        selectedVariant: selectedVariant,
        selectedSizeValue: `${event.value}`,
      });
    } else {
      this.setState({
        selectedVariant: selectedVariant,
        selectedColorValue: `${event.value}`,
      });
    }

    var index = this.props.product.images
      .map(function (e) {
        return e.id;
      })
      .indexOf(selectedVariant.image.attrs.id.value);

    this.slider.slickGoTo(index);
  }

  handleQuantityChange(event) {
    this.setState({
      selectedVariantQuantity: event.target.value,
    });
  }

  render() {
    let selectedOptions = this.state.selectedOptions;
    // selectedOptions["Color"] = this.props.product.options[0].values[0].value;
    const iniialSelectedVariant = this.props.client.product.helpers.variantForOptions(
      this.props.product,
      selectedOptions
    );
    var index = 0;
    if (this.props.product.images.length > 0 && iniialSelectedVariant !== undefined) {
      var index = this.props.product.images
        .map(function (e) {
          return e.id;
        }).indexOf(iniialSelectedVariant.image.attrs.id.value);
    }

    let variantImage = this.props.product.images;
    let variant = this.state.selectedVariant || this.props.product.variants[0];

    const settings = {
      customPaging: function (i) {
        return (
          <a>
            <img src={variantImage[i].src} />
          </a>
        );
      },
      dots: true,
      dotsClass: "slick-dots slick-thumb",
      infinite: true,
      initialSlide: index,
      fade: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    let variantQuantity = this.state.selectedVariantQuantity || 1;
    let desc1 = this.props.product.descriptionHtml;
    let desc = this.props.product.description.split("•");
    let firstInfo = desc[0];

    let variantSelectors = this.props.product.options.map((option) => {
      return (
        <VariantSelector
          handleOptionChange={this.handleOptionChange}
          key={option.id.toString()}
          option={option}
          fieldName={option.name.toString()}
          selectedSizeValue={this.state.selectedSizeValue}
          selectedColorValue={this.state.selectedColorValue}
        />
      );
    });

    return (
      <div style={{ height: "100%" }}>
        <button
          onClick={this.props.closeModal}
          className="Product__buy button modalCloseButton"
        >
          X
        </button>
        <div className="container" style={{ height: "100%", overflow: "auto" }}>
          <div
            className="card"
            style={{ border: "none", backgroundColor: "#fff" }}
          >
            <div className="container-fliud pt-4 mt-4">
              <div className="wrapper row">
                <div className="preview col-md-7 ">
                  <div className="preview-pic tab-content ">
                    <div className="container ">
                      <Slider
                        ref={(slider) => (this.slider = slider)}
                        {...settings}
                      >
                        {variantImage.map((img, index) => (
                          <div key={index}>
                            <img src={img.src} />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
                <div className="details col-md-5 ">
                  <h3 className="product-title">{this.props.product.title}</h3>
                  <h4 className="price">
                    <span style={{ color: "rgb(149, 137, 95)" }}>
                      $ {variant.price.amount}
                    </span>
                  </h4>

                  {variantSelectors}

                  <div className="qty-for-desktop">
                    <label style={{ fontSize: "14px", display: "block" }}>
                      Quantity
                    </label>
                  </div>

                  <div className="action">
                    <input
                      min="1"
                      className="Product_quantity_option mobile-view"
                      type="number"
                      defaultValue={variantQuantity}
                      onChange={this.handleQuantityChange}
                    ></input>
                    <Cart
                      variant_id={variant.id}
                      variantQuantity={variantQuantity}
                      isDetailPage={false}
                      closeModal={this.props.closeModal}
                    />
                  </div>

                  <div className="product-description mobile-view">
                    <div>{ReactHtmlParser(desc1)}</div>
                  </div>
                  <div className="product-description desktop-view">
                    <p>
                      {firstInfo}
                      <br />
                    </p>
                    <Link 
                      to={{ pathname: "/ProductDetail/" + this.props.category, search: "?id=" + this.props.product.id.toString() }}
                      className="add-to-cart btn btn-default"
                    >
                      View Detail
                    </Link>
                    {/* {this.props.isproductForSlide ? (
                      <button
                        onClick={() =>
                          this.props.changeProduct(this.props.product.id)
                        }
                        className="add-to-cart btn btn-default"
                      >
                        View Detail
                      </button>
                    ) : (
                        <Link
                          to={{ pathname: deatil_path }}
                          className="add-to-cart btn btn-default"
                        >
                          View Detail
                        </Link>
                      )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetails;


// WEBPACK FOOTER //
// ./src/components/ProductDetails.js